import { CSSResult, unsafeCSS } from 'lit';

export class Theme {
  private namespace: string;

  constructor(namespace: string) {
    this.namespace = namespace;
  }

  public static create(namespace: string) {
    return new Theme(namespace);
  }

  public propertyName = (name: string) =>
    unsafeCSS(`--tm-theme-${this.namespace}-${name}`);

  public var = (name: string, defaultValue?: string | CSSResult) => {
    const propertyName = this.propertyName(name);
    const property = `var(${propertyName}, ${defaultValue})`;
    return unsafeCSS(property);
  };

  public prop = (
    name: string,
    propertyName: string,
    defaultValue?: string | CSSResult,
  ) => {
    const value = this.var(propertyName, defaultValue);
    return unsafeCSS(`${name}: ${value};`);
  };

  public props = (props: Array<[string, string, string | CSSResult]>) => {
    const css: Array<CSSResult> = [];

    props.forEach((ruleSet) => {
      const prop = this.prop(ruleSet[0], ruleSet[1], ruleSet[2]);
      css.push(prop);
    });

    return unsafeCSS(css.join('\n'));
  };

  public scopedProps = (
    namespace: string,
    props: Array<[string, string | CSSResult]>,
  ) => {
    const css: Array<CSSResult> = [];

    props.forEach((ruleSet) => {
      const prop = this.prop(
        ruleSet[0],
        `${namespace}-${ruleSet[0]}`,
        ruleSet[1],
      );
      css.push(prop);
    });

    return unsafeCSS(css.join('\n'));
  };
}
